import Chronometer from 'app/components/Chronometer'
import ConfirmableSpinnable from 'app/components/buttons/ConfirmableSpinnable'
import DodoneStatsBase from 'app/dodones/shared/Stats/Base'
import StartedFinished from 'app/dodones/shared/StartedFinished'
import DodoneLink from 'app/dodones/Link'

const Trigger = ({ onClick }) => {
  return (
    <div className="dodone-list-item-icon-wrapper text-md" onClick={onClick}>
      <i className="dodone-list-item-icon" />
    </div>
  )
}

const DodoneLinkWrapper = ({ dodone, children, size = 'md' }) => {
  const [startedPending, setStartedPending] = useState(false)

  const startPending = useCallback((e) => {
    setStartedPending(true)
  })

  if (startedPending)
    return <Navigate to={`/dodones/${dodone.id}?startPending=true`} replace />

  return (
    <ConfirmableSpinnable
      onConfirm={startPending}
      enabled={dodone.isPending}
      Trigger={Trigger}
      className={dodone.itemClassName({ size })}
      confirmation="Start?"
      size="xs"
    >
      <DodoneLink dodoneId={dodone.id} className="flex-1">
        {children}
      </DodoneLink>
    </ConfirmableSpinnable>
  )
}

const DodoneItemPreview = ({ dodone, children }) => {
  return <div className={dodone.itemClassName()}>{children}</div>
}

export default ({ prefix, dodone, size = 'md' }) => {
  const Element = dodone.id ? DodoneLinkWrapper : DodoneItemPreview
  // const Element = Link // Test style without a hassle

  return (
    <Element dodone={dodone} size={size}>
      <div className={`dodone-list-item-content`}>
        {prefix ? (
          <div className="dodone-list-item-content-prefix"> {prefix} </div>
        ) : null}
        <div className="dodone-list-item-text">
          {dodone.iconClass && (
            <i className={`dodoable-list-item-icon ${dodone.iconClass}`} />
          )}
          {dodone.listItemText}
          <div className="flex-1" />
          <DodoneStatsBase dodone={dodone} />
        </div>
        {dodone.isOngoing && (
          <Chronometer startedAt={dodone.startedAt} size={'extra-small'} />
        )}
        <StartedFinished dodone={dodone} />
      </div>
    </Element>
  )
}
